import React from 'react'
import { ArrowForwardIcon, Button, Text } from '@resiliatech/birdsong'
import { StyledButton, ActionButton } from './MessagePopover.styled'
import { ButtonConfig } from './types'

type PopoverButtonProps = {
  primaryButton: ButtonConfig
  secondaryButton?: ButtonConfig
  showConfirmButtons?: boolean
}

export const PopoverButton = ({
  primaryButton,
  secondaryButton,
  showConfirmButtons,
}: PopoverButtonProps) =>
  showConfirmButtons ? (
    <>
      {secondaryButton && (
        <Button
          onClick={secondaryButton.onClick}
          variant='tertiary'
          label={secondaryButton.text}
        />
      )}
      <StyledButton
        $variant={primaryButton.variant}
        variant='contained'
        onClick={primaryButton.onClick}
      >
        {primaryButton.text}
      </StyledButton>
    </>
  ) : (
    <ActionButton onClick={primaryButton.onClick}>
      <Text>{primaryButton.text}</Text>
      <ArrowForwardIcon />
    </ActionButton>
  )
